/**
 * Suggestion-card ZIP only (TK-12977). US five-digit; hide ZIP+4 on the picker.
 * Canadian postcodes are unchanged. Do not use on shared `formatAddressLine`.
 */
export function fiveDigitZip(zip: string | null | undefined): string {
    const raw = String(zip ?? '').trim()
    const compact = raw.replace(/[\s-]/g, '')
    if (/^\d{5}$/.test(compact)) return compact
    if (/^\d{9}$/.test(compact)) return compact.slice(0, 5)
    return raw
}
